import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PagenotfoundGuard  {


  constructor(
    private router: Router,
  
    ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
   
    if (window.innerWidth <= 1300) {
      return true;
    } else {
     this.router.navigate(['**']);
      return false;
    }
  }
}
